import axios from 'axios'
import { useState } from "react"
import { useDebouncedEffect } from './useDebounceEffect'

interface IProps {
  url: string,
  body?,
  method?
  err?,
  then?: boolean
  onSuccess?: (data) => void
}

type UseRequest = <K>(props: IProps, deps?: any[], delay?: number) => [K | undefined, boolean, string]

export const useRequest: UseRequest = ({ url, body, method, onSuccess, then=true }, deps=[], delay=0) => {
  const [data, setData] = useState()
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('')
  
  const chooseMethod = method || (body ? 'post' : 'get');

  const controller = new AbortController();
  const { signal } = controller;
  
  useDebouncedEffect(() => {
    if (then) {
      setIsLoading(true);
      (async () => {
        try {
          const { data } = await axios[chooseMethod](url, body, { signal })
          setData(data)
          error && setError('')
          setIsLoading(false)
          onSuccess && onSuccess(data)

        } catch (e) {
          //если catch вызван AbortController, то не реагируем
          if (!axios.isCancel(e)) {
            const result = (e as Error).message
            result ? setIsLoading(false) : setIsLoading(true)
            setError(result)  
          }
        }
      })()
    }
  }, deps, delay, controller)

  return [data, isLoading, error]
}